import React from "react";
import Header from "./Header";

function Home() {
  return (
    <div className="container">
      {/* Hero Section */}
      <div className="bg-light p-3 rounded-lg my-3">
        <h1 className="display-6">Welcome to Our Store</h1>
        <p className="lead" style={{ fontSize: "0.9rem" }}>
          Discover amazing products and deals that you can't resist!
        </p>
        <a className="btn btn-primary btn-sm" href="#" role="button">
          Shop Now
        </a>
      </div>

      {/* Products Section */}
      <div className="container mt-3">
        <h2 className="text-center mb-3" style={{ fontSize: "1.25rem" }}>
          Featured Products
        </h2>
        <div className="row">
          {/* Product Card */}
          <div className="col-md-4">
            <div className="card mb-3">
              <img
                src="https://via.placeholder.com/300x200"
                className="card-img-top"
                alt="Product"
              />
              <div className="card-body" style={{ padding: "0.75rem" }}>
                <h5 className="card-title" style={{ fontSize: "1rem" }}>
                  Product Name
                </h5>
                <p className="card-text" style={{ fontSize: "0.85rem" }}>
                  Short description of the product.
                </p>
                <a href="#" className="btn btn-primary btn-sm">
                  View Details
                </a>
              </div>
            </div>
          </div>
          {/* Duplicate the product card for more products */}
          <div className="col-md-4">
            <div className="card mb-3">
              <img
                src="https://via.placeholder.com/300x200"
                className="card-img-top"
                alt="Product"
              />
              <div className="card-body" style={{ padding: "0.75rem" }}>
                <h5 className="card-title" style={{ fontSize: "1rem" }}>
                  Product Name
                </h5>
                <p className="card-text" style={{ fontSize: "0.85rem" }}>
                  Short description of the product.
                </p>
                <a href="#" className="btn btn-primary btn-sm">
                  View Details
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card mb-3">
              <img
                src="https://via.placeholder.com/300x200"
                className="card-img-top"
                alt="Product"
              />
              <div className="card-body" style={{ padding: "0.75rem" }}>
                <h5 className="card-title" style={{ fontSize: "1rem" }}>
                  Product Name
                </h5>
                <p className="card-text" style={{ fontSize: "0.85rem" }}>
                  Short description of the product.
                </p>
                <a href="#" className="btn btn-primary btn-sm">
                  View Details
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-light text-center text-lg-start mt-3">
        <div className="container p-3">
          <div className="text-center p-2" style={{ fontSize: "0.75rem" }}>
            © 2024 E-Commerce: 
            <a className="text-dark" href="#">
                JMeter Testing
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;
